import { getBreakpoint } from 'Utils/breakpoints.js';

$(window).on('load', function() {
    $('.case-study-info__slideshow').slick({
        adaptiveHeight: true,
        autoplay: false,
        autoplaySpeed: 12000,
        rows: 0,
        slidesToScroll: 4,
        slidesToShow: 4,
        slide: '.case-study-info__slide',
        prevArrow: '<span class="slick-arrow slick-arrow__prev"></span>',
        nextArrow: '<span class="slick-arrow slick-arrow__next"></span>',
        responsive: [
            {
                breakpoint: getBreakpoint('lg'),
                settings: {
                    arrows: false,
                    dots: true,
                    slidesToScroll: 1,
                    slidesToShow: 1
                }
            }
        ]
    });
});
